import { ElementUI } from '../../types/interfaces';
import IApiCalls from '../api/interfaces/apiCalls';

import BaseService from './BaseService';
import IElementUIsService from './interfaces/ElementUIsService';
import ServiceResult from './interfaces/ServiceResult';

class ElementUIsService
  extends BaseService<ElementUI>
  implements IElementUIsService
{
  constructor(apiCalls: IApiCalls) {
    super(apiCalls, 'ElementUIs');
  }

  getCurrentUserElementCodes(): ServiceResult<ElementUI[]> {
    const apiCalls = this._apiCalls.beginApiCalls();
    return {
      result: apiCalls.ElementUIs.getCurrentUserElementCodes(),
      cancel: apiCalls.cancelAllCalls
    };
  }
}

export default ElementUIsService;
